<template>
  <div>
    <v-col sm="12" md="12" lg="12">
      <v-row wrap align-center>
        <v-col cols="12">
          Computation progress...
          <v-progress-linear
            color="light-blue accent-4"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
export default {
  name: 'iol-progress-bar',
  props: ['fields'],
  data() {
    return {
      field: this.fields,
    }
  },
  created() {
    this.$emit('fields', this.field)
  },
}
</script>

<style></style>
